import { Alert } from './types';

export enum AlertKeys{
    PUSH_ALERT = 'notification/PUSH_ALERT',
    REMOVE_ALERT = 'notification/REMOVE_ALERT',
}

export interface PushAlert {
    type: AlertKeys.PUSH_ALERT;
    alert: Alert;
    notRemove?: boolean;
}
export interface RemoveAlert {
    type: AlertKeys.REMOVE_ALERT;
    alert: Alert;
    notRemove?: boolean;
}

export type AlertAction = | PushAlert | RemoveAlert;

export const pushAlert = (alert: Alert, notRemove?: boolean): PushAlert => ({
    alert,
    notRemove,
    type: AlertKeys.PUSH_ALERT,
});

export const removeAlert = (alert: Alert): RemoveAlert => ({
    alert,
    type: AlertKeys.REMOVE_ALERT,
});
